// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".LargeHero{overflow:hidden!important}.LargeHero .banner-placeholder{background-position:50%;background-size:cover;height:100%;width:100%}.LargeHero .v-div.--nudge-right{margin-right:-4px}.LargeHero .subTitle{font-weight:lighter}.LargeHero .whiteBackground{background:#fff}.LargeHero img.heroLogo{bottom:0;left:0;margin:auto;position:absolute;right:0;top:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
